import postLanguageChange from 'src/commons/apis/post-language-change';
import { SignInRedirectError } from 'src/commons/errors';
import { getUrlWithoutParameter } from 'src/commons/utils';

const QUERY_PARAM_RETURN_TO = 'openid.return_to';

const handleLanguageSwitch = async (
  currentLocale: string,
  newLocale: string,
  signOutUrl: string,
) => {
  try {
    await postLanguageChange(currentLocale, newLocale);
  } catch (error) {
    if (error instanceof SignInRedirectError) {
      const signOutUrlObject = new URL(signOutUrl);
      // override the login redirect to the current page user is on
      if (signOutUrlObject.searchParams.has(QUERY_PARAM_RETURN_TO)) {
        signOutUrlObject.searchParams.set(
          QUERY_PARAM_RETURN_TO,
          window.location.href,
        );
      }
      window.location.replace(signOutUrlObject.toString());
      return;
    }
  }

  const newUrl = getUrlWithoutParameter(window.location, 'locale');
  const newHref = `${window.location.origin}${newUrl}`;

  // If the URL has not changed we reload it else we replace it
  if (window.location.href === newHref) {
    window.location.reload();
  } else {
    window.location.replace(newUrl);
  }
};

export default handleLanguageSwitch;
